import { getItems, FIG_LISTS } from '../api/figApi';

const SEED_SETTINGS = {
  AgencyLegalName: 'Fragos Insurance Group, LLC',
  AgencyAddress: '16915 Walden Rd Suite 312',
  AgencyCity: 'Montgomery',
  AgencyState: 'TX',
  AgencyZip: '77356',
  AgencyPhone: '(936) 755-2521',
  AgencyEmail: 'marc@myfiginsurance.com',
  AgencyWebsite: 'myfiginsurance.com',
  BrandPrimaryHex: '#660099',
  BrandSecondaryHex: '#008b11',
  BrandTertiaryHex: '#4A0033',
  BrandAccentHex: '#B8860B',
  BrandTextHex: '#1A1A1A',
  BrandLogoHorizontalPath: 'Agency/Brand/fig_logo_horizontal.png',
  BrandLeafPath: 'Agency/Brand/fig_leaf.png',
  PaymentBankName: 'JPMorgan Chase Bank, NA',
  PaymentRouting: '111000614',
  PaymentAccount: '672110957',
  PaymentPayableTo: 'Fragos Insurance Group, LLC',
};

/**
 * Fetch agency settings from FIG_Settings list.
 * Returns the first record, or falls back to seed values with a console warning.
 */
export async function getAgencySettings(getToken) {
  try {
    const token = await getToken();
    const items = await getItems(token, FIG_LISTS.SETTINGS);
    if (items.length > 0) return items[0];
    console.warn('[InvoiceSettings] FIG_Settings list is empty — using seed defaults');
    return SEED_SETTINGS;
  } catch (err) {
    console.warn('[InvoiceSettings] Failed to fetch settings — using seed defaults:', err.message);
    return SEED_SETTINGS;
  }
}
